import React, { useEffect } from "react";
import styles from "./Symptoms.module.css";
import ArticleCoverAndHeader from "../ArticleComponents/ArticleCoverAndHeader";
import Row from "../ArticleComponents/Row";
import ImagesCollection from "../ArticleComponents/ImagesCollection";

function Symptoms() {
  const rows = [
    {
      heading: "What you need to know?",
      listItem: [
        "Anyone can have mild to severe symptoms.",
        "Older adults and people who have severe underlying medical conditions (they are termed as co-morbidities in medical terms) like heart or lung disease or diabetes seem to be at higher risk for developing more serious complications from COVID-19 illness.",
      ],
    },
    {
      heading: "The most common symptoms:",
      image_url:
        "https://drive.google.com/thumbnail?id=1_7D85dgAGtudloGi-Dekh09RXty9aIJd",
      listItem: [
        "Fever or chills",
        "Cough",
        "Shortness of breath or difficulty breathing",
        "Fatigue",
        "Muscle or body aches",
        "Headache",
        "New loss of taste or smell",
        "Sore throat",
        "Congestion or runny nose",
        "Nausea or vomiting",
        "Diarrhoea",
      ],
    },
    {
      heading: "Serious symptoms",
      listItem: [
        "difficulty breathing or shortness of breath",
        "chest pain or pressure",
        "loss of speech or movement",
        "On average it takes 5–6 days from when someone is infected with the virus for symptoms to show, however it can take up to 14 days.",
      ],
    },
  ];

  const newSymptoms = {
    heading:
      "The new set of symptoms, enlisted by a team of experts, mentioned that these are common indicators towards the exposure of virus:",
    listItem: [
      "Sore throat",
      "Muscle aches and joint pain",
      "Diarrhoea",
      "Conjunctivitis",
      "Headache",
      "Skin rash",
      "Discolouration of fingers or toes",
    ],
  };

  const SliderImagesData = [
    {
      image:
        "https://pbs.twimg.com/media/EUSxNGiWkAEDVvi?format=jpg&name=large",
    },
    {
      image:
        "https://community.apan.org/cfs-file/__key/communityserver-blogs-components-weblogfiles/00-00-01-35-61/Recover.PNG",
    },
  ];

  useEffect(() => {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  });

  return (
    <ArticleCoverAndHeader
      readTime={4}
      title="Recogonize Symptoms"
      author="Sanskruti Mishra"
      authorLink="https://www.instagram.com/sansi.1372/"
      author2="Shubham Maheshwari"
      authorLink2="https://www.instagram.com/_shubham.maheshwari/"
      nextGuide="/precautions"
    >
      <img
        className={`{${styles.articleFirstImage} ${styles.articleImageMobAlert}}`}
        src="https://blog.bonsecours.com/wp-content/uploads/2020/03/BSC_FB__SpotThe-Symptoms_1200x628-1024x536.png"
        alt="first_landscape_img"
      />

      <div className={styles.introPara}>
        <p>
        Vaccines save millions of lives each year. They work by training and preparing the body’s natural defences – the immune system – to recognize and fight off the viruses and bacteria they target. 
        Vaccines are a critical new tool in the battle against COVID-19 and it is hugely encouraging to see so many vaccines proving successful and going into development.
        Safe and effective vaccines will be a game changer: but for the foreseeable future we must continue wearing masks, physically distancing and avoiding crowds. 
        
        </p>
      </div>
      {rows.map((row) => (
        <Row row={row} />
      ))}

      <div className={styles.introPara}>
        <p>
          That said, latest reports have yet again suggested seven new symptoms
          of COVID-19 that differ from the most common three symptoms, ranging
          from{" "}
          <span className={styles.highlight}>
            fever, dry cough to loss of sense of smell and taste
          </span>
          . The aforementioned are the most common symptoms of covid-19
          according to the UK's National Health Services (NHS). While people are
          already aware of the most common symptoms of COVID-19, experts suggest
          a broader look into the spectrum of ailments caused by the deadly
          disease. The limited focus on just the classic symptoms poses great
          risk of spread and more danger to the health of the most vulnerable.
          The new set of symptoms are enlisted by a team of experts who
          mentioned that these are common indicators towards the exposure of
          virus.
        </p>
      </div>

      <Row row={newSymptoms} />

      <h2 className={styles.sliderHeader}>
        Some WHO Facts related to Covid-19
      </h2>

      <ImagesCollection SliderData={SliderImagesData} />

      <div className={styles.introPara}>
        <p>
          There is a notable fact that has to be considered. If you have
          contracted the virus via transmissions from a covid positive person,
          there are chances you{" "}
          <span className={styles.highlight}>might be asymptomatic</span>. It is
          necessary to get yourself{" "}
          <span className={styles.highlight}>tested</span> and take all the
          necessary{" "}
          <span className={styles.highlight}>
            precautions like quarantining yourself
          </span>{" "}
          at home so that none of the members of your family contract the virus.
        </p>
      </div>

      <div className={styles.introPara}>
        <p>
          Also, nowadays the scientists have proved that the virus <span className={styles.highlight}>“stays in the
          air”</span> this particularly means that the virus can survive in the air for
          a long time unlike the time when the virus became dormant after a
          small instance of time. Hence, an <span className={styles.highlight}>average healthy person can contract
          the virus via air too</span>. It is high time to note that a person can
          rampantly contribute towards the spread the virus even if he/she is
          asymptomatic. The only solution is to ensure that the person stays at
          home and wear a double mask even when you are at home. Kindly note
          that there are high chances of you might have a <span className={styles.highlight}>false negative when
          you take a test</span>. The right solution to this issue is to stay vigilant
          at all times and <span className={styles.highlight}> wear a double mask </span> in an attempt to not transmit to
          your near and dear ones.
        </p>
      </div>
    </ArticleCoverAndHeader>
  );
}

export default Symptoms;
